var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleReviewManagerHowItWork2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8239 2.40039L16.6542 7.3466L21.6004 9.17686L16.6542 11.0071L14.8239 15.9533L12.9937 11.0071L8.04745 9.17686L12.9937 7.3466L14.8239 2.40039Z",
    stroke: "#FAFAFF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35333 13.6945L7.95216 16.0486L10.3063 17.6475L7.95216 19.2463L6.35333 21.6004L4.75451 19.2463L2.40039 17.6475L4.75451 16.0486L6.35333 13.6945Z",
    stroke: "#FAFAFF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleReviewManagerHowItWork2);
export default __webpack_public_path__ + "static/media/google-review-manager-how-it-work-2.5472bb2fae566056149da0687d895cff.svg";
export { ForwardRef as ReactComponent };